import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course05 from "../../../course/course-05/course";
import lesson0503 from "../../../lesson/course-05/lesson-03/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "d29df992-840c-43bc-8200-19d1a04dc230",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0503),
    lesson: lesson0503,
  },
];

export default lessonLinks;
